import type { IRecordTypeDefinition, ISubTable } from '@platform/core/types';

/**
 * Ознака підтаблиці «Подробиці» дочірнього типу (метадані `subTable`: { key, order, label, columns } або `true` — з типовими підписом і
 * колонками): порядок, підпис картки й колонки; без ознаки — null. Чиста функція.
 */
export function subTableFlagOf(child: Pick<IRecordTypeDefinition, 'subTable'>): Partial<ISubTable> | null {
  const sub = child.subTable;
  if (!sub) return null;
  return sub === true ? {} : sub;
}
